import { Component, Input, OnInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LanguageApp } from 'src/app/config/datatable-config';
import { Helpers } from 'src/app/helpers/helpers';
import { RenaultPuntoapuntoCrmEntity, RenaultPuntoapuntoCrmEntityTable, RenaultPuntoapuntoCrmResultTable } from 'src/app/models/renault-puntoapunto-local-campaign-segmentation-dto';
import { SharedService } from 'src/app/services/shared.service';


@Component({
  selector: 'pap-entity-data-bar',
  templateUrl: './puntoapunto-entity-data-bar.component.html'
})
export class PuntoapuntoEntityDataBarComponent implements OnInit {


  @Input() model: RenaultPuntoapuntoCrmEntity;

  @Input() showImpacted: boolean = false;
  @Input() showAvailable: boolean = false;
  @Input() showSelected: boolean = false;
  @Input() selected: number;
  @Input() titleTotal: string;
  @Input() cssClass: string;


  constructor() {

  }

  ngOnInit(): void {



  }









}
